'use client'

import { Button } from '@landfolk/shared/ui/buttons/Button'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // TODO: Send error to Sentry once we upgrade the package for App Router support
    console.error(error)
  }, [error])

  return (
    <div tx="flex min-h-[400px] flex-col items-center justify-center p-4">
      <h2 tx="mb-3 text-f3 font-bold">Something went wrong!</h2>
      <p tx="mb-4 text-neutral-700">
        An error occurred while loading this page.
      </p>
      <Button
        onClick={() => reset()}
        tx="bg-february text-white hover:bg-february-muted"
      >
        Try again
      </Button>
    </div>
  )
}
